// Campus photo for /colleges/wellesley-college: CC BY-SA 3.0, by John Phelan, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGreen_Hall%2C_Wellesley_College%2C_Wellesley_MA.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/wellesley-college/; credited under the photo.
const photo = {
    "slug": "wellesley-college",
    "alt": "Green Hall and its Galen Stone Tower at Wellesley College in Wellesley, Massachusetts",
    "src": "/colleges/wellesley-college/campus-1600.webp",
    "srcSmall": "/colleges/wellesley-college/campus-800.webp",
    "srcMid": "/colleges/wellesley-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/wellesley-college/og.jpg",
    "title": "Green Hall, Wellesley College, Wellesley MA",
    "author": "John Phelan",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGreen_Hall%2C_Wellesley_College%2C_Wellesley_MA.jpg",
    "read": "2026-10-01"
};

export default photo;
